import type { InjectionKey, Ref } from 'vue';

export const darkModeKey: InjectionKey<Ref<boolean>> = Symbol('darkMode');
